import React from 'react';
import NeptuneLogo from 'assets/logo/neptune-logo.svg?react';

import { bemBlock } from '@neptune/shared/venus-ui';

import './KeycloakLogo.less';

const block = bemBlock('keycloak-logo');

type KeycloakLogoProps = {
  className?: string;
  size?: number;
};

export const KeycloakLogo: React.FC<KeycloakLogoProps> = ({ className, size }) => {
  return (
    <header className={block({ extra: className })}>
      <a href="/" target="_blank" className={block('image')}>
        <NeptuneLogo height={size} />
      </a>
    </header>
  );
};
